export var getEnvironment = function getEnvironment(diagnosticsEnvironment) {
  var map = {
    'master-prod': 'production',
    'master-nonprod': 'staging'
  };
  return map[diagnosticsEnvironment] || 'dev';
};